import {IShippingIntervalOptions, ISimpleSubProduct} from '../types';

const getCommonShippingInterval = (products: ISimpleSubProduct[]): IShippingIntervalOptions => {
  if (!products || products.length < 1) return null;

  const map: {
    [key: string]: number
  } = {};

  for (let i = 0; i < products.length; i++) {
    const product: ISimpleSubProduct = products[i];
    const intervalStr = `${product.shippingIntervalFrequency}|${product.shippingIntervalType}`;
    map[intervalStr] ? map[intervalStr]++ : map[intervalStr] = 1;
  }

  const highestOccurringIntervalStr: string = Object.keys(map).reduce((a, b) => map[a] > map[b] ? a : b);

  const resultArr: string[] = highestOccurringIntervalStr.split('|');
  const splitFrequencies: string[] = resultArr[0].split(',');

  return {
    shippingIntervalFrequencies: splitFrequencies,
    shippingIntervalType: resultArr[1],
    selectedFrequency: splitFrequencies[0]
  };
};

export default getCommonShippingInterval;